var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 24",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "creditcard"
  }, "Credit Card Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "creditcard"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cc-outline1{fill:none;}.cc-outline2{opacity:0.75;}.cc-outline3{fill:#4a4a49;fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cc-outline1",
    x: -615.63,
    y: -303.06,
    width: 1280,
    height: 1040
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cc-outline2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cc-outline3",
    d: "M33.5,0H2.5A2.5,2.5,0,0,0,0,2.5v19A2.5,2.5,0,0,0,2.5,24h31A2.5,2.5,0,0,0,36,21.5V2.5A2.5,2.5,0,0,0,33.5,0ZM35,21.5A1.5,1.5,0,0,1,33.5,23H2.5A1.5,1.5,0,0,1,1,21.5V10H35ZM1,6V2.5A1.5,1.5,0,0,1,2.5,1h31A1.5,1.5,0,0,1,35,2.5V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc-outline3",
    d: "M25,21h5a1.5,1.5,0,0,0,1.5-1.5v-5A1.5,1.5,0,0,0,30,13H25a1.5,1.5,0,0,0-1.5,1.5v5A1.5,1.5,0,0,0,25,21Zm-.5-6.5A.5.5,0,0,1,25,14h5a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5H25a.5.5,0,0,1-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc-outline3",
    d: "M5,17H15a.5.5,0,0,0,0-1H5a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc-outline3",
    d: "M5,19H15a.5.5,0,0,0,0-1H5a.5.5,0,0,0,0,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcOutline);
export default __webpack_public_path__ + "static/media/cc-outline.c0899b53bb3e83f2e327f0e5e505d992.svg";
export { ForwardRef as ReactComponent };